module.exports = __webpack_public_path__ + "res/28-img_prev.25ba9f969d5fe15ca359cf8003319c31.png";